


































import {
  Component,
  Mixins,
  Prop,
  Ref,
  Vue,
  Watch,
} from 'vue-property-decorator'

@Component
export default class ImageInput extends Vue {
  @Prop({ type: String })
  private value!: string | null

  @Prop({ type: String, default: '' })
  private basePath!: string

  @Prop({ type: [Number, String], default: 1 })
  private aspectRatio!: number | string

  @Prop({ type: Boolean, default: false })
  private readonly!: boolean

  @Prop({ type: String, default: 'Bild wählen ...' })
  private uploadMessage!: string

  @Prop({ type: String, default: 'Für Bildauswahl erst speichern' })
  private readonlyMessage!: string

  @Prop({ type: String, default: '#222' })
  private messageColor!: string

  @Prop({ type: String, default: '#fff' })
  private backgroundColor!: string

  @Ref()
  private fileInput!: HTMLInputElement

  private showMessage = this.value === null
  private showImage = true

  get imagePath() {
    let path = `${this.$env.VUE_APP_IMAGES_URL}/`
    if (this.basePath !== '') {
      path += `${this.basePath}/`
    }
    return path + this.value + `?${Math.round(Math.random() * 1000000)}`
  }

  get message() {
    if (this.readonly) {
      return this.readonlyMessage
    }
    return this.uploadMessage
  }

  // @Watch('basePath')
  // private basePathChanged() {}

  private openDialog() {
    if (this.readonly === false) {
      this.fileInput.click()
    }
  }

  private upload(e: Event) {
    const elem = e.target as HTMLInputElement
    if (elem.files && elem.files.length === 1) {
      this.$emit('change', elem.files[0])
    }
  }

  public reload() {
    this.showImage = false
    this.$nextTick(() => {
      this.showImage = true
    })
  }
}
